import {
    LoginWithPasswordRequestModel, 
    LoginWithPasswordResponseModel,
    CompaniesListRequestModel,
    CompaniesListResponseModel,
    ChangeCompanyStatusResponseModel,
    DeleteCompaniesListRequestModel,
    BaseResponseModel,
    ChangeCompanyStatusRequestModel,
    CreateCompanyRequestModel,
    CreateCompanyResponseModel,
    ChangeCompanyNameRequestModel,
    ChangeCompanyNameResponseModel,
    GetCompanyResponseModel,
    CompanyEmployeesListResponseModel,
    ChangeEmployeeStatusResponseModel,
    DeleteEmployeesListRequestModel,
    CreateEmployeeRequestModel,
    CreateEmployeeResponseModel,
    EditEmployeeResponseModel,
    GetCompanyEmployeeResponseModel,
    ChangeEmployeeStatusRequestModel,
    EditEmployeeRequestModel,
    GetCompanyWithUsersResponseModel,
    CategoriesListRequestModel,
    CategoriesListResponseModel,
    CreateCategoryRequestModel,
    ChangeCategoryNameRequestModel,
    ChangeCategoryStatusRequestModel,
    CreateCategoryResponseModel,
    ChangeCategoryNameResponseModel,
    ChangeCategoryStatusResponseModel,
    DeleteCategoriesListRequestModel,
    GetCategoryResponseModel,
    GetCategoryWithCriterionsResponseModel,
    CriterionsListByCategoryIdResponseModel,
    ChangeCriterionStatusRequestModel,
    ChangeCriterionStatusResponseModel,
    DeleteCriterionsListRequestModel,
    CreateCriterionRequestModel,
    CreateCriterionResponseModel,
    EditCriterionRequestModel,
    EditCriterionResponseModel,
    GetCriterionResponseModel,
    CriterionsListRequestModel,
    CriterionsListResponseModel,
    CategoriesFullListResponseModel,
    TransferCompanyOwnershipRequestModel,
    SubscriptionModel
} from '../types'
import { SubscriptionPlanModel, SubscriptionUpdateModel } from '../types/subscription'
import {Storage} from './../storage/Storage'

export abstract class BaseClient {

    public abstract loginWithPassword (model: LoginWithPasswordRequestModel): Promise<LoginWithPasswordResponseModel>

    public abstract getCompaniesList (model: CompaniesListRequestModel): Promise<CompaniesListResponseModel>

    public abstract changeCompanyStatus (id: number, model: ChangeCompanyStatusRequestModel): Promise<ChangeCompanyStatusResponseModel>

    public abstract deleteCompaniesList(model: DeleteCompaniesListRequestModel): Promise<BaseResponseModel>

    public abstract createCompany(model: CreateCompanyRequestModel): Promise<CreateCompanyResponseModel>

    public abstract changeCompanyName (id: number, model: ChangeCompanyNameRequestModel): Promise<ChangeCompanyNameResponseModel>

    public abstract getCompany (id: number): Promise<GetCompanyResponseModel>

    public abstract getCompanyWithUsers (id: number): Promise<GetCompanyWithUsersResponseModel>

    public abstract getCompanySubscription (id: number): Promise<SubscriptionModel>

    public abstract getPlansList (): Promise<SubscriptionPlanModel []>

    public abstract updateCompanySubscription (id: number, model: SubscriptionUpdateModel): Promise<SubscriptionModel>

    public abstract createEmployee(companyId: number, model: CreateEmployeeRequestModel): Promise<CreateEmployeeResponseModel>

    public abstract deleteEmployeesList(model: DeleteEmployeesListRequestModel): Promise<BaseResponseModel>

    public abstract getEmployee (id: number): Promise<GetCompanyEmployeeResponseModel>
    
    public abstract editEmployee(id: number, model: EditEmployeeRequestModel): Promise<EditEmployeeResponseModel>

    public abstract changeEmployeeStatus (id: number, model: ChangeEmployeeStatusRequestModel): Promise<ChangeEmployeeStatusResponseModel> 
    
    public abstract getCompanyEmployeesList (id: number): Promise<CompanyEmployeesListResponseModel>    
    
    public abstract getCategoriesList (model: CategoriesListRequestModel): Promise<CategoriesListResponseModel>

    public abstract getCategoriesFullList (): Promise<CategoriesFullListResponseModel>

    public abstract changeCategoryStatus (id: number, model: ChangeCategoryStatusRequestModel): Promise<ChangeCategoryStatusResponseModel>

    public abstract deleteCategoriesList(model: DeleteCategoriesListRequestModel): Promise<BaseResponseModel>

    public abstract createCategory(model: CreateCategoryRequestModel): Promise<CreateCategoryResponseModel>

    public abstract changeCategoryName (id: number, model: ChangeCategoryNameRequestModel): Promise<ChangeCategoryNameResponseModel>

    public abstract getCategory (id: number): Promise<GetCategoryResponseModel>

    public abstract getCategoryWithCriterions (id: number): Promise<GetCategoryWithCriterionsResponseModel>

    public abstract getCriterionsListByCategoryId (id: number): Promise<CriterionsListByCategoryIdResponseModel>    

    public abstract changeCriterionStatus (id: number, model: ChangeCriterionStatusRequestModel): Promise<ChangeCriterionStatusResponseModel> 

    public abstract deleteCriterionsList(model: DeleteCriterionsListRequestModel): Promise<BaseResponseModel>

    public abstract createCriterion(model: CreateCriterionRequestModel): Promise<CreateCriterionResponseModel>

    public abstract editCriterion(id: number, model: EditCriterionRequestModel): Promise<EditCriterionResponseModel>

    public abstract getCriterion (id: number): Promise<GetCriterionResponseModel>

    public abstract getCriterionsList (model: CriterionsListRequestModel): Promise<CriterionsListResponseModel>

    public abstract transferCompanyOwnership(id: number, model: TransferCompanyOwnershipRequestModel): Promise<BaseResponseModel>

    protected readonly parseResponse  = (response: Response) => {        
        if (response.ok) {
            return response.json()
        }
        else {            
            if(response.status == 401) {
                const storage = new Storage()
                storage.clear()     
                window.location.href = '/'
            }
        }       
    } 
}